import { render, staticRenderFns } from "./selectMore.vue?vue&type=template&id=07ba0dee&"
import script from "./selectMore.vue?vue&type=script&lang=ts&"
export * from "./selectMore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports